import React from 'react';
import isNil from 'lodash-es/isNil';
import { gql } from '@yi/core';

import { graphql, useStaticQuery } from 'gatsby';
import { TeacherCarousel } from '~/src/components/carousels/TeacherCarousel';

import { sortCardsByIds } from '../sortCardsByIds';

interface Props {
  children: (data: React.ComponentProps<typeof TeacherCarousel>['items']) => React.ReactNode;
}
const list = [
  // Gaby Zermeño
  'teacher_710646',
  // Carla Sánchez
  '6u8Dy03NXXS2LUGTWtluhC',
  // Gabriela Tavera
  'teacher_742587',
  // Alex Quiyono
  'teacher_766475',
  // Almudena Sánchez
  '6DqUVrK8t27CxWUX10AyTP',
  // Pritam Pal
  'teacher_719769',
  // Twiggy Romero
  'teacher_688565',
  // Laila Kuri
  'teacher_724215',
  // Esteban Salazar
  'teacher_697215',
  // Yogaflor
  'teacher_2101448',
];

export const TeachersCarouselDataES: React.FC<Props> = ({ children }) => {
  const yiData = useStaticQuery<gql.typesSsr.Query_AllTeachers_LOH_EN>(graphql`
    query Query_AllTeachers_LOH_ES {
      yi {
        allTeachers(
          filter: {
            ids: [
              "teacher_710646"
              "6u8Dy03NXXS2LUGTWtluhC"
              "teacher_742587"
              "teacher_766475"
              "6DqUVrK8t27CxWUX10AyTP"
              "teacher_719769"
              "teacher_688565"
              "teacher_724215"
              "teacher_697215"
              "teacher_2101448"
            ]
          }
        ) {
          ...Fragment_TeacherCard
        }
      }
    }
  `);

  const data = yiData?.yi?.allTeachers;
  if (isNil(data)) {
    return null;
  }
  const sortedData = sortCardsByIds(data, list);

  return <>{children(sortedData)}</>;
};
